import { useAppContext } from '@/contexts/AppContext';
import { Link } from '@tanstack/react-router';
import type { FC } from 'react';

interface Props {
  showCTA?: boolean;
  title: string;
  subtitle: string;
}

const Hero: FC<Props> = ({ showCTA = true, title, subtitle }) => {
  const { community } = useAppContext();

  return (
    <div className="relative h-[500px] md:h-[600px] lg:h-[700px] flex items-center justify-center">
      {/* Background Image with Overlay */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${community.hero?.url})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">{title}</h1>
        <p className="text-lg md:text-xl lg:text-2xl mb-8 md:mb-10 max-w-3xl mx-auto uppercase tracking-widest">
          {subtitle}
        </p>

        {showCTA && (
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/floor-plans"
              className="inline-block px-8 py-4 bg-accent-600 text-white rounded-none font-semibold uppercase tracking-wider hover:bg-accent-700 transition-colors duration-200"
            >
              View Floor Plans
            </Link>
          </div>
        )}
      </div>

      {/* Scroll Indicator */}
      {showCTA && (
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path d="M19 14l-7 7m0 0l-7-7m7 7V3" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default Hero;
